export default __webpack_public_path__ + "img/270e48eddfd6e01b8901e7c65e27f948.svg";